import script from "./Tswiper1.vue?vue&type=script&setup=true&lang=js"
export * from "./Tswiper1.vue?vue&type=script&setup=true&lang=js"

import "./Tswiper1.vue?vue&type=style&index=0&id=44b546cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b546cc"]])

export default __exports__